import { signal, WritableSignal } from '@angular/core';

export function alwaysSignal<T>(initialValue: T): WritableSignal<T> {
  return signal(initialValue, { equal: () => false });
}
